export const version = "contracts/5.5.0";
//# sourceMappingURL=_version.js.map